import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { OverChargeClaimComment } from '@/views/screens/Claims/types';

import { getOCClaimNextPage } from '../utils/get-next-page';

export const PAGE_SIZE_DEFAULT = 10;

export interface GetOCClaimCommentsRequestParams {
  fbOcKey: number;
  pageIndex: number;
  pageSize?: number;
  sortColumn?: string;
  sortDirection?: 'ASC' | 'DESC';
}

export interface OCClaimCommentsResponse {
  data: OverChargeClaimComment[];
  nextPage?: number;
  totalRows: number;
}

export const getOCClaimCommentsAPI = (params: GetOCClaimCommentsRequestParams) => {
  return axiosInstance.request({
    method: 'get',
    params: {
      fbOcKey: params.fbOcKey,
      pageIndex: params.pageIndex,
      pageSize: params.pageSize || PAGE_SIZE_DEFAULT,
      sortColumn: params.sortColumn || 'SequenceNo',
      sortDirection: params.sortDirection || 'DESC',
    },
    url: `${API.OVERCHARGE_CLAIM}/GetClaimComments`,
  });
};

export const fetchOCClaimComments = async (
  params: GetOCClaimCommentsRequestParams,
): Promise<OCClaimCommentsResponse> => {
  const response: AxiosResponse<OCClaimCommentsResponse> = await getOCClaimCommentsAPI(params);
  const data = response.data;
  const pageSize = Number(params.pageSize || PAGE_SIZE_DEFAULT);
  const pageData = data.data ?? [];

  return {
    ...data,
    nextPage: getOCClaimNextPage(Number(params.pageIndex), pageSize, Number(data.totalRows ?? 0), pageData.length),
  };
};
